module.exports = __webpack_public_path__ + "img/wallet-desc-active.08352f01.png";